import Showdown from 'showdown'
import Vue from 'vue'

const Converter = new Showdown.Converter()

Vue.directive('md', {

  inserted: (el, binding) => {
    const md = binding.value
    const html = Converter.makeHtml(md)

    el.innerHTML = html

    const attributes = Object.keys(el.dataset).filter(attr => attr.match(/^v\-/))
    const elements = el.querySelectorAll('*')

    elements.forEach((element) => {
      attributes.forEach(attr => element.setAttribute('data-' + attr, ''))
    })
  }

})



// WEBPACK FOOTER //
// ./src/services/v-md.js